import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { Button } from "@dishopsaas/design-system";
import * as styles from "../AccountForm.styles";
import { getActionContainer } from '../AccountForm.styles'
import { isDarkTheme } from "../../../utils";

export const AccountActionsSection = ({
  color,
  title,
  subTitle,
  buttonLabel,
  colorType,
  buttonIcon,
  onClick,
  description,
}: any) => {
  const theme = useTheme()
  const actionContainer = getActionContainer()
  return (
    <Box sx={{ ...actionContainer, background: isDarkTheme() ? theme.palette.background.default : color }}>
      <Box sx={{ ...styles.passwordBox, flexDirection: "column" }}>
        <Typography variant="body1" sx={{ fontWeight: 700 }}>
          {title}
        </Typography>
        <Typography variant="body1">{subTitle}</Typography>
        <Box sx={styles.content}>
          <Button
            colorType={colorType}
            label={buttonLabel}
            leftIcon={buttonIcon}
            onClick={onClick}
            size="medium"
          />

          <Typography variant="caption">{description}</Typography>
        </Box>
      </Box>
    </Box>
  )
};
